module.exports = __webpack_public_path__ + "static/media/clarity_circle-arrow-line.55efba12.svg";